<div class="input-search">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <input type="text" class="font-secondary" formControlName="search" (blur)="onSubmit()" />
        <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path
                    id="Path_339"
                    data-name="Path 339"
                    d="M9.089,2A7.089,7.089,0,1,1,2,9.089,7.091,7.091,0,0,1,9.089,2Zm0,12.6A5.513,5.513,0,1,0,3.575,9.089,5.512,5.512,0,0,0,9.089,14.6Zm6.683.056L18,16.885,16.885,18l-2.227-2.228,1.114-1.114Z"
                    transform="translate(-2 -2)"
                    fill="#d5d5d5"
                />
            </svg>
        </div>
    </form>
</div>
